function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { EXPLORE_ALL_PICTURES, PROPERTY_PICTURES } from "../../../utils/default-strings";
import { getFirstNItems } from "../../../utils/get-first-n-items";
import { Grid } from "../../layout/Grid";
import { GridColumn } from "../../layout/GridColumn";
import { ResponsiveImage } from "../../media/ResponsiveImage";
import { Heading } from "../../typography/Heading";
import { Gallery } from "../../media/Gallery";
import { Link } from "../../elements/Link";
import { testidFactory } from "../../../utils/testid";
var TEST_ID_PREFIX = 'pictures';
var testid = testidFactory(TEST_ID_PREFIX);
export var Component = function Component(_ref) {
  var id = _ref.id,
      galleryImages = _ref.galleryImages,
      headingText = _ref.headingText,
      linkText = _ref.linkText,
      numberOfThumbnails = _ref.numberOfThumbnails;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = useState(2),
      _useState4 = _slicedToArray(_useState3, 2),
      currentIndex = _useState4[0],
      setIndex = _useState4[1];

  var triggerIsOpen = function triggerIsOpen(index) {
    setIsOpen(true);
    setIndex(index);
  };

  var close = function close() {
    return setIsOpen(false);
  };

  var adaptThumbnailImages = function adaptThumbnailImages(images) {
    return images.map(function (_ref2) {
      var url = _ref2.url,
          descriptionText = _ref2.descriptionText;
      return {
        imageUrl: url,
        imageUrlAlternativeText: descriptionText,
        label: descriptionText
      };
    });
  };

  return React.createElement(Grid, {
    id: id
  }, React.createElement(GridColumn, {
    width: 12
  }, React.createElement(Heading, null, headingText)), React.createElement("section", {
    className: "property-pictures"
  }, getFirstNItems(numberOfThumbnails, adaptThumbnailImages(galleryImages)).map(function (imageProps, index) {
    return React.createElement("div", {
      className: "image-container",
      "data-testid": testid("thumbnail_".concat(index)),
      key: index,
      onClick: function onClick() {
        triggerIsOpen(index);
      }
    }, React.createElement(ResponsiveImage, _extends({}, imageProps, {
      className: "gallery-thumbnail",
      isFluid: true,
      willFill: true
    })));
  })), React.createElement(GridColumn, {
    width: 12
  }, React.createElement(Gallery, {
    "data-testid": testid('gallery'),
    images: galleryImages,
    isOpen: isOpen,
    onClick: triggerIsOpen,
    onClose: close,
    startIndex: currentIndex,
    trigger: React.createElement(Link, {
      "data-testid": testid('triggerLink'),
      onClick: function onClick() {
        triggerIsOpen(0);
      }
    }, linkText)
  })));
};
Component.displayName = 'Pictures';
Component.defaultProps = {
  id: null,
  headingText: PROPERTY_PICTURES,
  linkText: EXPLORE_ALL_PICTURES,
  numberOfThumbnails: 6
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  galleryImages: PropTypes.arrayOf(PropTypes.shape({
    descriptionText: PropTypes.string,
    sizes: PropTypes.string,
    srcSet: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string.isRequired
  })).isRequired,
  headingText: PropTypes.string,
  id: PropTypes.string,
  linkText: PropTypes.string,
  numberOfThumbnails: PropTypes.number
} : {};